/**
 * v-reveal 滚动显现指令
 * 用法: v-reveal 或 v-reveal="{ delay: 200 }"
 */
const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target
        el.classList.add('reveal-visible')
        observer.unobserve(el)
      }
    })
  },
  { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
)

export default {
  mounted(el, binding) {
    el.classList.add('reveal')
    if (binding.value && binding.value.delay) {
      el.style.transitionDelay = `${binding.value.delay}ms`
    }
    observer.observe(el)
  },
  unmounted(el) {
    observer.unobserve(el)
  }
}
